<template>
    <div class="auth-mask position-fixed vw-100 vh-100">
        <b-row no-gutters class="justify-content-center vw-100 vh-100">
            <b-col sm="6" class="px-5 align-self-center">
                <form
                    @submit.prevent="ready"
                    v-if="response.status != 200"
                    >
                    <b-form-group>
                        <b-form-input
                            v-model="form.email"
                            ref="formEmail"
                            type="email"
                            placeholder="your@email.com"
                            required
                            >
                        </b-form-input>
                        <input-error :errors="error.email" />
                    </b-form-group>
                    <b-button block class="btn-theme" @click="ready">
                        ログイン
                        <template v-if="config.APP_ENABLE_REGISTER">
                            /
                            登録
                        </template>
                    </b-button>
                </form>
                <form
                    @submit.prevent="login"
                    v-if="response.status == 200"
                    >
                    <b-form-group>
                        <span>メールで届いた認証コード</span>
                        <b-form-input
                            v-model="form.onetime_password"
                            ref="formOnetimePassword"
                            type="text"
                            placeholder="123456"
                            required
                            @input="login"
                            >
                        </b-form-input>
                        <input-error :errors="error.onetime_password" />
                    </b-form-group>
                    <b-link @click="step1">再送信</b-link>
                </form>

                <p
                    class="text-center my-5"
                    v-if="! config.APP_ENABLE_REGISTER"
                    >
                    まだ登録していない場合、<a href="/">こちら</a>から申込いただけます。
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'auth_token',
            'trans',
            'config',
        ])
    },
    data() {
        return {
            form: {
                email: null,
                onetime_password: null,
            },
            response: {},
            error: {},
        }
    },
    mounted() {
        this.step1()
    },
    methods: {
        ready () {
            this.response = Object.assign({})
            this.$store
                .dispatch('auth/ready', Object.assign(this.form, { onetime_password_type: 'login', }))
                .then((response) => {
                    this.response = Object.assign({}, response)
                    this.step2()
                })
                .catch((error) => {
                    this.error = error
                })
        },
        login () {
            if ((this.form.onetime_password || '').length != 6) {
                return
            }
            this.$store
                .dispatch('auth/login', this.form)
                .then((response) => {
                    this.step1()
                    this.$store.dispatch('app/data')
                })
                .catch((error) => {
                    this.error = error
                })
        },
        step1 () {
            this.form.email = null
            this.form.onetime_password = null

            this.response = Object.assign({})
            this.error = Object.assign({})

            this.$nextTick(() => {
                this.$refs.formEmail.focus()
            })
        },
        step2 () {
            this.form.onetime_password = null

            this.error = Object.assign({})

            this.$nextTick(() => {
                this.$refs.formOnetimePassword.focus()
            })
        },
    },
}
</script>

<style>
.auth-mask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: #fff;
}
</style>
